import React from 'react';
import type { BuiltResume } from '../../../resume-engine/types';
import { ResumeSection } from './ResumeSection';

interface Props {
  contact: BuiltResume['contact'];
}

export function ContactSection({ contact }: Props) {
  return (
    <ResumeSection title="Contact Information">
      <div className="resume-contact-block">
        <p>Email: {contact.email}</p>
        <p>Location: {contact.location}</p>
        <p>LinkedIn: {contact.linkedin}</p>
        <p>GitHub: {contact.github}</p>
        <p>Portfolio: {contact.website}</p>
      </div>
    </ResumeSection>
  );
}
